import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/images/arrow_left_black.svg'


const _hoisted_1 = { class: "v-card" }
const _hoisted_2 = { class: "v-card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "svg align-text-bottom text-black me-1",
  height: "18",
  width: "18",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "v-card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 form-group" }
const _hoisted_7 = { for: "ClientType" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { for: "ClientName" }
const _hoisted_11 = ["placeholder", "disabled"]
const _hoisted_12 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = { for: "Sex" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { for: "Phone" }
const _hoisted_18 = ["placeholder", "disabled"]
const _hoisted_19 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_20 = { for: "Email" }
const _hoisted_21 = ["placeholder", "disabled"]
const _hoisted_22 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_23 = { class: "col-md-6 form-group" }
const _hoisted_24 = { for: "Country" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["value"]
const _hoisted_27 = { for: "City" }
const _hoisted_28 = ["placeholder", "disabled"]
const _hoisted_29 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_30 = { for: "Region" }
const _hoisted_31 = ["placeholder", "disabled"]
const _hoisted_32 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_33 = { for: "AdressLine1" }
const _hoisted_34 = ["placeholder", "disabled"]
const _hoisted_35 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_36 = { class: "col-md-12 form-group" }
const _hoisted_37 = { for: "AdressLine2" }
const _hoisted_38 = ["placeholder", "disabled"]
const _hoisted_39 = { class: "col-md-12 form-group" }
const _hoisted_40 = { for: "Note" }
const _hoisted_41 = ["placeholder", "disabled"]
const _hoisted_42 = { class: "col-md-6 form-group" }
const _hoisted_43 = { for: "ClientLang" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "col-md-6 form-group" }
const _hoisted_47 = { for: "Tags" }
const _hoisted_48 = { class: "col-md-6 form-group" }
const _hoisted_49 = { class: "form-check" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  class: "form-check-label",
  for: "AcceptMarketing"
}
const _hoisted_52 = { class: "col-md-6 form-group" }
const _hoisted_53 = { class: "form-check" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  class: "form-check-label",
  for: "TaxExempted"
}
const _hoisted_56 = { class: "mx-3 my-4" }
const _hoisted_57 = { class: "mt-4" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_tag_input_v2 = _resolveComponent("jw-tag-input-v2")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createVNode(_component_RouterLink, { to: "/app/customers/list" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.windowTitle), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.language.type), 1),
          _withDirectives(_createElementVNode("select", {
            id: "ClientType",
            name: "ClientType",
            class: "form-control-sel",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataRecord.ClientType) = $event)),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientTypes, (cType) => {
              return (_openBlock(), _createElementBlock("option", {
                key: cType.id,
                value: cType.id
              }, _toDisplayString(cType.label), 9, _hoisted_9))
            }), 128))
          ], 8, _hoisted_8), [
            [_vModelSelect, _ctx.dataRecord.ClientType]
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.ClientName.$error}])
        }, [
          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.language.name), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "ClientName",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRecord.ClientName) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ')',
            maxlength: "35",
            autocomplete: "off",
            onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_11), [
            [_vModelText, _ctx.dataRecord.ClientName]
          ]),
          (_ctx.v$.dataRecord.ClientName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.v$.dataRecord.ClientName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.language.sex), 1),
          _withDirectives(_createElementVNode("select", {
            id: "Sex",
            name: "Sex",
            class: "form-control-sel",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataRecord.Sex) = $event)),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sexes, (sex) => {
              return (_openBlock(), _createElementBlock("option", {
                key: sex.id,
                value: sex.id
              }, _toDisplayString(sex.label), 9, _hoisted_16))
            }), 128))
          ], 8, _hoisted_15), [
            [_vModelSelect, _ctx.dataRecord.Sex]
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Phone.$error}])
        }, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.language.phone), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "Phone",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataRecord.Phone) = $event)),
            placeholder: '(' + _ctx.language.phoneSample.toLowerCase() + ')',
            maxlength: "10",
            autocomplete: "off",
            onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectOnFocus($event))),
            onkeypress: "return event.charCode >= 48 && event.charCode <= 57",
            disabled: _ctx.isSavingRecord || _ctx.isLoading || _ctx.dataRecord.IdClient !== 0
          }, null, 40, _hoisted_18), [
            [_vModelText, _ctx.dataRecord.Phone]
          ]),
          (_ctx.v$.dataRecord.Phone.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.v$.dataRecord.Phone.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Email.$error}])
        }, [
          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.language.email), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "Email",
            class: "form-control",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.Email) = $event)),
            placeholder: '(' + _ctx.language.emailSample.toLowerCase() + ')',
            maxlength: "50",
            autocomplete: "off",
            onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading || _ctx.dataRecord.IdClient !== 0
          }, null, 40, _hoisted_21), [
            [_vModelText, _ctx.dataRecord.Email]
          ]),
          (_ctx.v$.dataRecord.Email.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.v$.dataRecord.Email.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.language.country), 1),
          _withDirectives(_createElementVNode("select", {
            id: "Country",
            name: "Country",
            class: "form-control-sel",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataRecord.Country) = $event)),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (ctry) => {
              return (_openBlock(), _createElementBlock("option", {
                key: ctry.code,
                value: ctry.code
              }, _toDisplayString(ctry.name), 9, _hoisted_26))
            }), 128))
          ], 8, _hoisted_25), [
            [_vModelSelect, _ctx.dataRecord.Country]
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.City.$error}])
        }, [
          _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.language.city), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "City",
            class: "form-control",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataRecord.City) = $event)),
            placeholder: '(' + _ctx.language.city.toLowerCase() + ')',
            maxlength: "50",
            autocomplete: "off",
            onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_28), [
            [_vModelText, _ctx.dataRecord.City]
          ]),
          (_ctx.v$.dataRecord.City.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.v$.dataRecord.City.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Region.$error}])
        }, [
          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.language.region), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "Region",
            class: "form-control",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataRecord.Region) = $event)),
            placeholder: '(' + _ctx.language.region.toLowerCase() + ')',
            maxlength: "50",
            autocomplete: "off",
            onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_31), [
            [_vModelText, _ctx.dataRecord.Region]
          ]),
          (_ctx.v$.dataRecord.Region.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.v$.dataRecord.Region.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-12 form-group", {'has-error': _ctx.v$.dataRecord.AdressLine1.$error}])
        }, [
          _createElementVNode("label", _hoisted_33, [
            _createTextVNode(_toDisplayString(_ctx.language.address_line_1) + " (", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.language.required.toLowerCase()), 1),
            _createTextVNode(")")
          ]),
          _withDirectives(_createElementVNode("textarea", {
            type: "text",
            id: "AdressLine1",
            class: "form-control",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dataRecord.AdressLine1) = $event)),
            placeholder: '(' + _ctx.language.address_line_1.toLowerCase()  + ')',
            maxlength: "500",
            rows: "3",
            onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_34), [
            [_vModelText, _ctx.dataRecord.AdressLine1]
          ]),
          (_ctx.v$.dataRecord.AdressLine1.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.v$.dataRecord.AdressLine1.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.language.address_line_2), 1),
          _withDirectives(_createElementVNode("textarea", {
            type: "text",
            id: "AdressLine2",
            class: "form-control",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dataRecord.AdressLine2) = $event)),
            placeholder: '(' + _ctx.language.address_line_2.toLowerCase()  + ')',
            maxlength: "500",
            rows: "3",
            onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_38), [
            [_vModelText, _ctx.dataRecord.AdressLine2]
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.language.note), 1),
          _withDirectives(_createElementVNode("textarea", {
            type: "text",
            id: "Note",
            class: "form-control",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dataRecord.Note) = $event)),
            placeholder: '(' + _ctx.language.note.toLowerCase()  + ')',
            maxlength: "1000",
            rows: "3",
            onFocus: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 40, _hoisted_41), [
            [_vModelText, _ctx.dataRecord.Note]
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.language.language), 1),
          _withDirectives(_createElementVNode("select", {
            id: "ClientLang",
            name: "ClientLang",
            class: "form-control-sel",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dataRecord.ClientLang) = $event)),
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
              return (_openBlock(), _createElementBlock("option", {
                key: lang.id,
                value: lang.id
              }, _toDisplayString(lang.label), 9, _hoisted_45))
            }), 128))
          ], 8, _hoisted_44), [
            [_vModelSelect, _ctx.dataRecord.ClientLang]
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.language.tags), 1),
          _createVNode(_component_jw_tag_input_v2, {
            initialTags: _ctx.tags,
            onAfterUpdate: _ctx.updateTags,
            disabled: _ctx.isSavingRecord || _ctx.isLoading
          }, null, 8, ["initialTags", "onAfterUpdate", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "AcceptMarketing",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dataRecord.AcceptMarketing) = $event)),
              disabled: _ctx.isSavingRecord || _ctx.isLoading
            }, null, 8, _hoisted_50), [
              [_vModelCheckbox, _ctx.dataRecord.AcceptMarketing]
            ]),
            _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.language.accept_marketing), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "AcceptMarketing",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dataRecord.TaxExempted) = $event)),
              disabled: _ctx.isSavingRecord || _ctx.isLoading
            }, null, 8, _hoisted_54), [
              [_vModelCheckbox, _ctx.dataRecord.TaxExempted]
            ]),
            _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.language.tax_exempted), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-block",
          disabled: _ctx.v$.$invalid || _ctx.isSavingRecord || _ctx.isLoading,
          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.saveNewCustomer && _ctx.saveNewCustomer(...args)))
        }, [
          (_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
                _createTextVNode("  ")
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
        ], 8, _hoisted_58)
      ])
    ])
  ]))
}